import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-floating col-xl-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex justify-content-end" }

import { ref, watch, computed } from 'vue';
    import NumberInput from "../common/NumberInput.vue";
    import Dropdown from '../common/Dropdown.vue';
    import IncomeGuidanceSummary from './IncomeGuidanceSummary.vue';
    import Help from "@/guiide/components/common/Help.vue";
    import HelpText from "@/guiide/ts/helpText";
    import { InitialIncomeProfile } from '@/guiide/ts/wants/initialIncomeProfile';
    import Constants from '@/guiide/ts/constants';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'InitialIncomeSetup',
  props: {
        suggestedAmountOnPLSADate: { type: Number, default: 0 },
        baseIncome: { type: Number, default: 0 },
        extraInitialIncome: { type: Number, default: 0 },
        visible: { type: Boolean, default: true },
        modalMode: { type: Boolean, default: false }
    },
  emits: ["populate-income-plan", "cancelled"],
  setup(__props, { expose: __expose, emit: __emit }) {

    __expose({ initialize, getIncome });

    const props = __props;

    const emit = __emit;

    const baseIncomeNumberInput = ref<typeof NumberInput>(null);
    const extraIncomeNumberInput = ref<typeof NumberInput>(null);
    const extraIncomeDurationDropDown = ref<typeof Dropdown>(null);
    const baseIncomeModel = ref(0);
    const extraIncomeModel = ref(0);
    const extraIncomeYears = ref('5');

    function initialize() {
        baseIncomeNumberInput.value.takeFocus();
    }

    watch(() => props.baseIncome, (newBaseIncome) => {
        baseIncomeModel.value = newBaseIncome;
    });

    watch(() => props.extraInitialIncome, (newExtraIncome) => {
        extraIncomeModel.value = newExtraIncome;
    });

    const extraIncomeYearsIsOptional = computed<boolean>(() => {
        return extraIncomeModel.value == 0;
    });

    function onPopulateIncomePlanClicked() {
        if (!(baseIncomeNumberInput.value.isValid()
            && extraIncomeNumberInput.value.isValid()
            && extraIncomeDurationDropDown.value.isValid())) {
            return
        }

        const eventArg: InitialIncomeProfile = {
            baseIncome: baseIncomeModel.value,
            extraIncome: extraIncomeModel.value,
            extraIncomeYears: parseInt(extraIncomeYears.value)
        };

        emit('populate-income-plan', eventArg);
    }

    function getIncome(): { baseIncome: number, extraIncome: number } {
        return { baseIncome: baseIncomeModel.value, extraIncome: extraIncomeModel.value };
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (__props.modalMode)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " After tax income "))
        : (_openBlock(), _createBlock(IncomeGuidanceSummary, {
            key: 1,
            "income-setup-mode": true,
            "suggested-amount-on-plsa-date": __props.suggestedAmountOnPLSADate
          }, null, 8, ["suggested-amount-on-plsa-date"])),
      _createVNode(NumberInput, {
        ref_key: "baseIncomeNumberInput",
        ref: baseIncomeNumberInput,
        modelValue: baseIncomeModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((baseIncomeModel).value = $event)),
        class: "col-xl-4",
        description: "After tax income",
        min: _unref(Constants).MinAnnualIncome,
        max: _unref(Constants).MaxAnnualIncome
      }, null, 8, ["modelValue", "min", "max"])
    ], 512), [
      [_vShow, __props.visible]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, [
        _cache[4] || (_cache[4] = _createTextVNode(" Want some extra income in the first few years? ")),
        _createVNode(Help, {
          title: "First few years",
          text: _unref(HelpText).ReqmntFirstFewYears()
        }, null, 8, ["text"])
      ]),
      _createVNode(NumberInput, {
        ref_key: "extraIncomeNumberInput",
        ref: extraIncomeNumberInput,
        modelValue: extraIncomeModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((extraIncomeModel).value = $event)),
        class: "col-xl-4",
        description: "Extra income",
        min: 0,
        max: 100000
      }, null, 8, ["modelValue"])
    ], 512), [
      [_vShow, __props.visible]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _cache[5] || (_cache[5] = _createElementVNode("p", null, " For how many years? ", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Dropdown, {
            ref_key: "extraIncomeDurationDropDown",
            ref: extraIncomeDurationDropDown,
            items: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
            modelValue: extraIncomeYears.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((extraIncomeYears).value = $event)),
            optional: extraIncomeYearsIsOptional.value,
            description: "Extra income years",
            "abbreviated-description": "Extra income years",
            classes: "form-select form-control"
          }, null, 8, ["modelValue", "optional"])
        ])
      ])
    ], 512), [
      [_vShow, __props.visible]
    ]),
    (__props.visible && !__props.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("p", null, " When you're happy with your answers, click the 'Generate your income plan' button to see your income chart. If you make any changes, just click the button again to update it! ", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: onPopulateIncomePlanClicked
          }, " Generate your income plan ")
        ]))
      : (__props.visible && __props.modalMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: onPopulateIncomePlanClicked
              }, "Update your income plan"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary ms-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('cancelled')))
              }, "Cancel")
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})